import Vue from "vue";
import _ from "lodash";
// import constants from "@/assets/constants";

export default {
  namespaced: true,
  state: {
    initialized: false,
    userTeams: null,
    joinRequests: null,
    activeTeam: null,
    userTeamMembers: null,
    teamNames: {}
  },
  mutations: {
    /**
     * Internal use, prevent double-setup ws listeners
     * @param {*} state
     * @param {*} value
     */
    setInitialized(state, value) {
      state.initialized = value;
    },
    clearUserTeams(state) {
      state.userTeams = {};
    },
    setUserTeams(state, teams) {
      teams.forEach(team => {
        Vue.set(state.userTeams, team.id, team);
      });
    },
    removeUserTeam(state, teamID) {
      Vue.delete(state.userTeams, teamID);
    },
    clearJoinRequests(state) {
      state.joinRequests = {};
    },
    addJoinRequest(state, request) {
      var len = _.size(state.joinRequests);
      Vue.set(state.joinRequests, len, request);
    },
    setActiveTeam(state, teamID) {
      var activeTeam = localStorage.getItem("ActiveTeam");
      if (state.userTeams[activeTeam]) {
        state.userTeams[activeTeam].active = false;
      }

      if (teamID == null) {
        localStorage.setItem("ActiveTeam", null);
        state.activeTeam = null;
        return;
      }

      state.userTeams[teamID].active = true;
      localStorage.setItem("ActiveTeam", teamID);
      state.activeTeam = state.userTeams[teamID];
    },
    setTeamMembers(state, members) {
      state.userTeamMembers = {};
      members.forEach(member => {
        if (!state.userTeamMembers[member.id]) {
          Vue.set(state.userTeamMembers, member.id, {});
        }

        Vue.set(state.userTeamMembers[member.id], member.user_id, member);
      });
    },
    removeTeamMember(state, { teamID, memberID }) {
      Vue.delete(state.userTeamMembers[teamID], memberID);
    },
    updateMemberRole(state, { teamID, memberID, role }) {
      state.userTeamMembers[teamID][memberID].role = role;
    },
    setTeamRole(state, { teamID, role }) {
      state.userTeams[teamID].role = role;
    },
    registerTeamName(state, team) {
      Vue.set(state.teamNames, team.team_id, team.name);
    }
  },
  actions: {
    /**
     * Runs only once (when not initialized),
     * sets up all the necessary topquiz handlers to manage this store
     * @param {*} me
     * @param {*} vm
     */
    storeCreated(me, vm) {
      if (me.state.initialized === true) {
        return;
      }

      me.commit("setInitialized", true);

      vm.$topquiz.on(this, "getUserTeams_success", params => {
        me.commit("clearUserTeams");

        var teams = params[0];
        me.commit("setUserTeams", teams);

        var activeTeam = localStorage.getItem("ActiveTeam");
        var foundActiveTeam = -1;

        teams.forEach(team => {
          team.active = activeTeam == team.id;
          if (team.active) {
            foundActiveTeam = team.id;
          }
        });

        if (foundActiveTeam > 0) {
          me.commit("setActiveTeam", foundActiveTeam);
          return;
        }

        if (teams.length == 0) {
          me.commit("setActiveTeam", null);
          return;
        }

        me.commit("setActiveTeam", teams[0].id);
      });

      vm.$topquiz.on(this, "getTeamJoinRequests_success", params => {
        me.commit("clearJoinRequests");

        var requests = params[0];
        requests.forEach(request => {
          me.commit("addJoinRequest", request);
        });
      });

      vm.$topquiz.on(this, "teamRequest", () => {
        me.dispatch("loadJoinRequests", vm);
      });

      vm.$topquiz.on(this, "denyRequest_success", () => {
        me.dispatch("loadJoinRequests", vm);
      });

      vm.$topquiz.on(this, "acceptRequest_success", () => {
        me.dispatch("loadJoinRequests", vm);
        me.dispatch("loadUserTeams", vm);
      });

      vm.$topquiz.on(this, "getTeamMembers_success", params => {
        var members = params[0];
        me.commit("setTeamMembers", members);
      });

      vm.$topquiz.on(this, "kickedMember", params => {
        var teamID = params[0];
        var memberID = params[1];

        if (memberID == me.rootState.userID) {
          me.commit("removeUserTeam", teamID);
        }
        me.commit("removeTeamMember", { teamID, memberID });
      });

      vm.$topquiz.on(this, "leftTeam", params => {
        var teamID = params[0];
        var memberID = params[1];

        if (memberID == me.rootState.userID) {
          me.commit("removeUserTeam", teamID);
        }
        me.commit("removeTeamMember", { teamID, memberID });
      });

      vm.$topquiz.on(this, "changedMemberRole", params => {
        var teamID = params[0];
        var memberID = params[1];
        var role = params[2];

        if (memberID == me.rootState.userID) {
          me.commit("setTeamRole", { teamID, role });
        }

        me.commit("updateMemberRole", { teamID, memberID, role });
      });
    },
    /**
     * Loads all teams for the current user from the database, replacing the old ones
     * @param {*} me
     * @param {*} vm
     */
    loadUserTeams(me, vm) {
      me.dispatch("storeCreated", vm);
      vm.$topquiz.sendCommand("getUserTeams", vm.$topquiz.SessionKey);
      vm.$topquiz.sendCommand("getTeamMembers", vm.$topquiz.SessionKey);
    },
    /**
     * Loads all teams for the current user from the database, replacing the old ones
     * @param {*} me
     * @param {*} vm
     */
    loadJoinRequests(me, vm) {
      me.dispatch("storeCreated", vm);
      vm.$topquiz.sendCommand("getTeamJoinRequests", vm.$topquiz.SessionKey);
    },
    setActiveTeam(me, teamID) {
      me.commit("setActiveTeam", teamID);
    },
    registerTeamName(me, team) {
      me.commit("registerTeamName", team);
    }
  },
  getters: {
    sortedTeamList(state) {
      var sortedTeams = _.sortBy(state.userTeams, [
        team => team.name.toLowerCase()
      ]);
      return sortedTeams;
    },
    teamCount(state) {
      return _.size(state.userTeams);
    },
    showNotification(state) {
      return _.size(state.joinRequests) > 0;
    },
    activeTeamID(state) {
      if (state.activeTeam) {
        return state.activeTeam.id;
      }

      return localStorage.getItem("ActiveTeam");
    },
    teamNames: state => id => {
      var name = state.teamNames[id];
      if (name) {
        return name;
      }

      return id;
    }
  }
};
